import {ShieldIcon} from '../../../icons'
import {SimpleBlueButton} from '../../core/button'

const DisabledView = ({text, onEnable}) => (
    <div className='security-card'>
        <div className='security-card-content'>
            <div className='security-icon'>
                <ShieldIcon />
            </div>

            <div className='security-info'>
                <h3 className='security-card-title'>{text.mfa_title}</h3>
                <p className='security-card-description'>{text.mfa_description}</p>
                <span className='security-badge security-badge--disabled'>{text.disabled}</span>
            </div>

            <SimpleBlueButton type='button' onClick={onEnable}>
                {text.enable_2fa}
            </SimpleBlueButton>
        </div>
    </div>
)

export default DisabledView
